import { useSelector } from '@bonanza-social/toolkit/state';
import {
  selectReferralRegistrationOffer,
  selectRegistrationFormPromoId,
  selectRegistrationOffer,
} from '../state';
import { useMemo } from 'react';

export function useRegistrationPromos() {
  const referralPromo = useSelector(selectReferralRegistrationOffer());
  const offerId = useSelector(selectRegistrationFormPromoId) || -1;
  const selectedWelcomePromo = useSelector(selectRegistrationOffer(offerId));

  const isSelectedPromoReferral = useMemo(() => {
    return (
      (selectedWelcomePromo?.promoType === 'Welcome' &&
        selectedWelcomePromo?.subPromoType === 'Referral') ||
      (selectedWelcomePromo?.promoType === 'Referral' &&
        selectedWelcomePromo?.subPromoType === 'Generic')
    );
  }, [selectedWelcomePromo]);

  return { referralPromo, selectedWelcomePromo, isSelectedPromoReferral };
}
